<template>
  <div class="md-layout">
    <div id="objectHeaderContentHidden" style="display: none;">
      <div>
        <md-icon class="icon-color">{{list.pageIcon}}</md-icon>
      </div>
      <div>
        <h1 class="md-title icon-color">{{ $route.name }}</h1>
      </div>
    </div>
    <div class="md-layout-item">
      <ElasticList :list="list" :filter="taskTemplateFilter"></ElasticList>
    </div>
  </div>
</template>

<script>
import ElasticList from "@/components/DynamicForm/ElasticList";

export default {
  components: {
    ElasticList,
  },
  computed: {
    //filter data with isTemplate: true, remove isTemplate: false & null records
    taskTemplateFilter: function () {
      return { bool: { must: { match: { isTemplate: true } } } };
    },
  },
  data() {
    return {
      list: {
        hideListHeader: true,
        linkRows: true,
        editPath: "tasktemplates",
        pageTitle: "Task Templates",
        pageIcon: "assessment",
        listQueryId: "searchTaskStepsListCustoms",
        deleteQueryId: "deleteTask",
        deleteMessageNameFields: ["subject"],
        deleteSyncQueryId: "deleteTaskStep",
        responseFieldName: "searchTasks",
        columns: {
          subject: { label: "Subject", sortable: true },
          type: { label: "Type", sortable: true },
          priority: { label: "Priority", sortable: true },
          createdAt: { label: "CreatedAt", sortable: true },
          //updatedAt: { label: "updatedAt", sortable: true },
          status: { label: "Status", sortable: true },
        },
        perPageOptions: [5, 10, 20, 25, 50],
        defaults: {
          sort: "createdAt",
          sortDir: "desc",
          perPage: 10
        },
        fuseSearch: null,
      }
    };
  }
};
</script>

<style></style>
